import { MERGE_LEVELS, MergeLevel } from "./mergeGame.ts";

/*
 * The one thing Factor Merge keeps besides the best scores (ADR 0128 §5, §7): the
 * grade last chosen, so the page opens on it. The scores live with every other
 * game's in bestScore.ts. Same read-validate / try-write habit: nothing leaves
 * the browser, and a full or disabled store costs nothing but the memory.
 */
const STORAGE_KEY = "mathpages.mergeGame";

/** The page opens on Grade 3 until a grade has been chosen. A level saved under the old bands ("g35", "g68") is not one of the grades, so it opens Grade 3 too (ADR 0128 §7). */
export const DEFAULT_MERGE_LEVEL: MergeLevel = "g3";

export function readMergeLevel(): MergeLevel {
    try {
        const stored = window.localStorage.getItem(STORAGE_KEY);
        const parsed = stored ? JSON.parse(stored) : null;
        if (parsed && typeof parsed === "object" && MERGE_LEVELS.includes(parsed.level)) {
            return parsed.level;
        }
    } catch {
        // Unavailable or unreadable: the default.
    }
    return DEFAULT_MERGE_LEVEL;
}

export function saveMergeLevel(level: MergeLevel): void {
    try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ level }));
    } catch {
        // Full, disabled, or unavailable. A level is not worth an error.
    }
}
